<div class="container" [ngClass]="printActive ? 'return-view-background-print' : 'return-view-background'">
    <div>
        <div class="row mt-2 mb-4">
            <div class="col-sm-4"></div>
            <div class="col-sm-4 text-center font-weight-bold">
                <div>National Board of Revenue</div>
                <div>www.nbr.gov.bd</div>
            </div>
            <div class="col-sm-4 d-flex justify-content-end align-items-center font-weight-bold">IT-11GA (2023)</div>
        </div>
        <div class="row">
            <div class="col-sm-4 bt bb bl br" style="font-size:14px">
                <div class="row bt bb bl br">
                    <div class="col-12 text-center font-weight-bold py-1">For Office Use</div>
                </div>
                <div class="row bt bb bl br">
                    <div class="col-8 br py-1">Serial No. of Return Register</div>
                    <div class="col-4 bl py-1 px-0 text-center">{{returnData?.submissionInfo?.submissionStatus ? returnData?.submissionInfo?.referenceNo : ''}}</div>
                </div>
                <div class="row bt bb bl br">
                    <div class="col-8 br py-1">Volume No. of Return Register</div>
                    <div class="col-4 bl py-1 px-0 text-center"></div>
                </div>
                <div class="row bt bb bl br">
                    <div class="col-8 br py-1">Date of Return Submission</div>
                    <div class="col-4 bl py-1 px-0 text-center">{{submissionDate}}</div>
                </div>
            </div>
            <div class="col-sm-4 m-auto text-center">
              <b>FORM OF RETURN OF INCOME FOR INDIVIDUAL PERSON</b>
              <br/><br/>
              <div>Section: {{ section?.value }} [{{ section?.label }}]</div>
            </div>
            <div class="col-sm-4">

            </div>
        </div>

      <div class="row mt-2" *ngIf="returnData?.submissionInfo?.timeExtensionEntryNumber">
        <div class="col-sm-4 bt bb bl br" style="font-size:14px">
          <div class="row bt bb bl br">
            <div class="col-8 br py-1">Time Extension Entry Number</div>
            <div class="col-4 bl py-1 px-0 text-center">{{returnData?.submissionInfo?.timeExtensionEntryNumber ? returnData?.submissionInfo?.timeExtensionEntryNumber : ''}}</div>
          </div>

        </div>
      </div>


        <div class="row mt-4" style="border: 2px solid #666">
           <div class="col-sm-12">
                <div class="row my-4">
                    <div class="col-sm-3">1. Name of the Taxpayer:</div>
                    <div class="col-sm-9 float-left">{{userInfo?.assesName}}</div>
                </div>
                <div class="row my-4">
                    <div class="col-sm-4">2. National ID No. / Passport No. (If No NID):</div>
                    <div class="col-sm-7">
                        <!-- {{userInfo?.nid | convertNumWithOtherCharsToBn}} -->
                        {{userInfo?.smartId && userInfo?.smartId != '' ? userInfo?.smartId : userInfo?.nid }}
                    </div>
                </div>
                <div class="row my-4">
                    <div class="col-sm-2">3. TIN:</div>
                    <div class="col-sm-10">
                        <input value="{{item}}" *ngFor="let item of userInfo?.tin?.split('')" class="input-default" disabled/>
                    </div>
                </div>
                <div class="row my-4">
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-4">4. (a) Circle</div>
                            <div class="col-sm-8">{{userInfo?.circle}}</div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-4">(b) Taxes Zone:</div>
                            <div class="col-sm-8">{{userInfo?.zone}}</div>
                        </div>
                    </div>
                </div>
                <div class="row my-4 mr-5">
                    <div class="col-sm-4">
                        <div class="row">
                            <div class="col-sm-7">
                               5. Assessment Year:
                            </div>
                            <div class="col-sm-5">
                                {{userInfo?.assessmentYear }}
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        6. Residential Status:
                    </div>
                    <div class="col-sm-2">
                        <div class="row">
                            <div class="col-sm-6">Resident</div>
                            <div class="col-sm-6">
                                <input [checked]="userInfo?.residentStatus == 'Resident'" class="input-checkbox" type="checkbox" disabled/>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="row">
                            <div class="col-sm-8">Non-resident</div>
                            <div class="col-sm-4">
                                <input [checked]="userInfo?.residentStatus == 'Non Resident'" class="input-checkbox" type="checkbox" disabled/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row my-4 mr-5">

                  <div class="col-sm-3">
                      7. Taxpayer’s Status:
                  </div>
                  <div class="col-sm-2">
                      <div class="row">
                          <div class="col-sm-6">Individual</div>
                          <div class="col-sm-6">
                              <input checked="true" class="input-checkbox" type="checkbox" disabled/>
                          </div>
                      </div>
                  </div>
                  <div class="col-sm-1">
                      <div class="row">
                          <div class="col-sm-7">Firm</div>
                          <div class="col-sm-5">
                              <input class="input-checkbox" type="checkbox" disabled/>
                          </div>
                      </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="row">
                        <div class="col-sm-9" style="padding-left: 40px">Hindu Undivided Family</div>
                        <div class="col-sm-3">
                            <input  class="input-checkbox" type="checkbox" disabled/>
                        </div>
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="row">
                      <div class="col-sm-6">Others</div>
                      <div class="col-sm-6">
                          <input  class="input-checkbox" type="checkbox" disabled/>
                      </div>
                    </div>
                   </div>
                </div>
                <div class="row my-4">
                    <div class="col-sm-12">
                      8. Tick (&#10003;) on the box for getting special benefit:
                    </div>
                </div>
                <div class="row my-4 mr-5">
                    <div class="col-sm-4">
                        <div class="row">
                            <div class="col-sm-8">A gazette war-wounded freedom fighter</div>
                            <div class="col-sm-4">
                                <input [checked]="userInfo?.warWoundedFreedomFighter" class="input-checkbox" type="checkbox" disabled/>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="row">
                            <div class="col-sm-6">Female</div>
                            <div class="col-sm-6">
                                <input [checked]="userInfo?.gender == 'F'" class="input-checkbox" type="checkbox" disabled/>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="row">
                            <div class="col-sm-8">Third Gender</div>
                            <div class="col-sm-4">
                                <input [checked]="userInfo?.gender == 'O'" class="input-checkbox" type="checkbox" disabled/>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="row">
                            <div class="col-sm-8">Disable Person</div>
                            <div class="col-sm-4">
                                <input [checked]="userInfo?.personWithDisability" class="input-checkbox" type="checkbox" disabled/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row my-4 mr-5">
                    <div class="col-sm-4">
                        <div class="row">
                            <div class="col-sm-8">Aged 65 years or more</div>
                            <div class="col-sm-4">
                                <input [checked]="userInfo?.age" class="input-checkbox" type="checkbox" disabled/>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-8">
                        <div class="row">
                            <div class="col-sm-6">A parent of a person with disability</div>
                            <div class="col-sm-6 text-left">
                                <input [checked]="userInfo?.guardianOfDisablePerson" class="input-checkbox" type="checkbox" disabled/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row my-4">
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-12">
                              <div class="mb-2">
                                  9. Date of Birth (DD MM YYYY):
                              </div>
                            </div>
                            <div class=" ml-4">
                                <span class="mr-3">
                                    <input style="text-align: center;" *ngFor="let item of dobMonthChars" class="input-default" value="{{item }}" disabled/>
                                </span>
                                <span class="mr-3">
                                    <input style="text-align: center;" *ngFor="let item of dobDayChars" class="input-default" value="{{item }}" disabled/>
                                </span>
                                <span class="mr-3">
                                    <input style="text-align: center;" *ngFor="let item of dobYearChars" class="input-default" value="{{item }}" disabled/>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 pt-2">
                        <div class="row mb-2">
                            <div class="col-sm-12">
                              10. Wife/Husband's Name: {{userInfo?.spouseName}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 ml-3">
                                TIN (if spouse is a Taxpayer): {{userInfo?.spouseTin}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row my-4">
                    <div class="col-sm-12">
                        11. Address: {{userInfo?.presentAddress}}
                    </div>
                </div>

                <div class="row mr-5 ml-2">
                    <div class="col-sm-4 ">Telephone: {{userInfo?.phone }}</div>
                    <div class="col-sm-3 ">Mobile: {{userInfo?.phone }}</div>
                    <div class="col-sm-5 ">e-mail: {{userInfo?.email}}</div>
                </div>
                <div class="row my-4">
                    <div class="col-sm-12">
                        12. If employed, employer’s name (latest employer’s name in case of multiple employment):
                        {{lastEmployer}}
                    </div>
                </div>
                <div class="row my-4">
                    <div class="col-sm-12">
                        13. (a) Name of Organization:
                    </div>
                </div>
                <div class="row my-4">
                    <div class="col-sm-12 ml-4">
                        (b) Business Identification number (BIN): {{userInfo?.businessIdNumber}}
                    </div>
                </div>
                <div class="row my-4">
                    <div class="col-sm-12">
                        14. Name and TIN of Partners / Members in case of Firm / Association of Persons:
                    </div>
                </div>
                <div class="row my-2">
                    <div class="col-sm-12"></div>
                </div>
           </div>
        </div>
    </div>
</div>
